export default __webpack_public_path__ + "static/media/Norxit-ban.54be1d4a.jpg";